export function linkToAnonymousResourcesPage() {
  return `/resources`;
}
